import { Box } from "@mui/material"
import { memo, useContext } from "react"
import { CondominiosContext } from "../../../Providers/CondominiosContext/CondominiosContext"

import { NumeroCondStyle } from './sxNumeroCond'

const NumeroCond = ({ id_central, handleChangeCond }) => {
    const { activeCond } = useContext(CondominiosContext)
    let classNumero = NumeroCondStyle

    if (activeCond.id_central === id_central) {
        classNumero.fontWeight = 700
        classNumero.backgroundColor = '#A8A4AB'
    } else {
        classNumero.fontWeight = 400
        classNumero.backgroundColor = 'transparent'
    }

    return (
        <Box sx={classNumero} id={`cond_${id_central}`} onClick={() => { handleChangeCond(id_central, true) }}>
            {id_central}
        </Box>
    )
}

export default memo(NumeroCond)
